<template>
    <ArchivesPanel/>
</template>

<script>
import ArchivesPanel from './ArchivesPanel'
export default {
    name: 'Archives',
    components: {
        ArchivesPanel
    }
}
</script>

<style>

</style>